<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Configuración de WhatsApp</h4>
          <div class="btn-group">
            <button class="btn btn-primary" (click)="showCreateForm()" *ngIf="!showForm">
              <i class="ti ti-plus"></i> Nueva Configuración
            </button>
            <button class="btn btn-outline-success" (click)="sendTestMessage()">
              <i class="ti ti-message"></i> Enviar Prueba
            </button>
          </div>
        </div>

        <div class="card-body">
          <!-- Form -->
          <div *ngIf="showForm" class="mb-4">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">{{ editingId ? 'Editar' : 'Nueva' }} Configuración de WhatsApp</h5>
              </div>
              <div class="card-body">
                <form [formGroup]="configForm" (ngSubmit)="onSubmit()">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Proveedor *</label>
                        <select class="form-control" formControlName="provider" (change)="onProviderChange()">
                          <option value="">Seleccionar proveedor</option>
                          <option *ngFor="let provider of providers" [value]="provider.value">
                            {{ provider.label }}
                          </option>
                        </select>
                        <small class="form-text text-muted" *ngIf="configForm.get('provider')?.value">
                          {{ getProviderDescription(configForm.get('provider')?.value) }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">URL de API *</label>
                        <input type="url" class="form-control" formControlName="api_url" 
                               placeholder="https://api.example.com/messages">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">API Key *</label>
                        <input type="text" class="form-control" formControlName="api_key" 
                               placeholder="Tu API Key">
                      </div>
                    </div>
                    <div class="col-md-6" *ngIf="isFieldRequired('api_secret')">
                      <div class="mb-3">
                        <label class="form-label">API Secret {{ isFieldRequired('api_secret') ? '*' : '' }}</label>
                        <input type="password" class="form-control" formControlName="api_secret" 
                               placeholder="Tu API Secret">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6" *ngIf="isFieldRequired('phone_number_id')">
                      <div class="mb-3">
                        <label class="form-label">Phone Number ID {{ isFieldRequired('phone_number_id') ? '*' : '' }}</label>
                        <input type="text" class="form-control" formControlName="phone_number_id" 
                               placeholder="ID del número de teléfono">
                        <small class="form-text text-muted">Solo para WhatsApp Business API</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Número Remitente *</label>
                        <input type="tel" class="form-control" formControlName="from_number" 
                               placeholder="+573001234567">
                        <small class="form-text text-muted">Número desde el cual se enviarán los mensajes</small>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" formControlName="is_active" id="isActive">
                      <label class="form-check-label" for="isActive">
                        Configuración activa
                      </label>
                      <small class="form-text text-muted d-block">
                        Solo puede haber una configuración activa a la vez
                      </small>
                    </div>
                  </div>

                  <!-- Required Fields Info -->
                  <div *ngIf="configForm.get('provider')?.value" class="alert alert-info">
                    <h6>Campos requeridos para {{ getProviderName(configForm.get('provider')?.value) }}:</h6>
                    <ul class="mb-0">
                      <li *ngFor="let field of getRequiredFields()">{{ field }}</li>
                    </ul>
                  </div>

                  <div class="d-flex gap-2">
                    <button type="submit" class="btn btn-primary" [disabled]="!configForm.valid">
                      {{ editingId ? 'Actualizar' : 'Crear' }}
                    </button>
                    <button type="button" class="btn btn-secondary" (click)="cancelForm()">
                      Cancelar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Configurations List -->
          <div *ngIf="loading" class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
          </div>

          <div *ngIf="!loading && configurations.length === 0" class="text-center py-4">
            <p class="text-muted">No hay configuraciones de WhatsApp</p>
          </div>

          <div *ngIf="!loading && configurations.length > 0" class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Proveedor</th>
                  <th>URL API</th>
                  <th>Número Remitente</th>
                  <th>Estado</th>
                  <th>Fecha Creación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let config of configurations">
                  <td>
                    <div>
                      <strong>{{ getProviderName(config.provider) }}</strong>
                      <br>
                      <small class="text-muted">{{ config.provider }}</small>
                    </div>
                  </td>
                  <td>
                    <small class="text-truncate d-block" style="max-width: 200px;" [title]="config.api_url">
                      {{ config.api_url }}
                    </small>
                  </td>
                  <td>
                    <code>{{ config.from_number }}</code>
                  </td>
                  <td>
                    <span class="badge" [class]="config.is_active ? 'bg-success' : 'bg-secondary'">
                      {{ config.is_active ? 'Activo' : 'Inactivo' }}
                    </span>
                  </td>
                  <td>
                    <small>{{ config.created_at | date:'short' }}</small>
                  </td>
                  <td>
                    <div class="btn-group btn-group-sm" role="group">
                      <button class="btn btn-outline-primary" (click)="editConfiguration(config)" title="Editar">
                        <i class="ti ti-edit"></i>
                      </button>
                      <button class="btn btn-outline-success" (click)="testConfiguration(config)" title="Probar">
                        <i class="ti ti-test-pipe"></i>
                      </button>
                      <button class="btn btn-outline-danger" (click)="deleteConfiguration(config)" title="Eliminar">
                        <i class="ti ti-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Provider Information -->
          <div class="mt-4">
            <div class="card">
              <div class="card-header">
                <h6 class="mb-0">Información de Proveedores</h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4" *ngFor="let provider of providers">
                    <div class="card mb-3">
                      <div class="card-body">
                        <h6 class="card-title">{{ provider.label }}</h6>
                        <p class="card-text">{{ provider.description }}</p>
                        <small class="text-muted">
                          <strong>Campos requeridos:</strong><br>
                          {{ provider.required_fields.join(', ') }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
